// src/components/search/MobileSearchDrawer.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSearchSuggestions,
  clearSearch
} from "../../../slices/search";
import "./header.css";

export default function MobileSearchDrawer({ open, onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { suggestions, loading } = useSelector((state) => state.search);

  const [query, setQuery] = useState("");

  useEffect(() => {
    const delay = setTimeout(() => {
      if (query.trim().length > 0) {
        dispatch(fetchSearchSuggestions(query));
      } else {
        dispatch(clearSearch());
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [query, dispatch]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [open]);

  const handleSelect = (slug) => {
    document.body.style.overflow = "auto"; 
    onClose();
    navigate(`/product/${slug}`);
  };

  return (
    <>
      {open && (
        <div
          className="mobile-search-backdrop"
          onClick={onClose}
        ></div>
      )}

      <div className={`mobile-search-drawer ${open ? "open" : ""}`}>

        <div className="drawer-header">
          <input
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search products..."
            autoFocus
          />
          <button onClick={onClose} className="close-btn">
            ✕
          </button>
        </div>

        <div className="drawer-content">
          {loading && <p className="loading-text">Searching...</p>}

          {!loading &&
            suggestions?.map((s) => (
              <div
                key={s.id}
                className="drawer-item"
                onClick={() => handleSelect(s.slug)}
              >
                <img src={s.primary_image} alt="" />
                <span>{s.name}</span>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
